import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HostingData} from "./hostingData";
import {HostingService} from "../hosting.service";
import {Website} from "../../website";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {GeneratePasswordComponent} from "./generate-password-dialog/generate-password.component";
import * as fromStore from '../../../../store';
import {Store} from '@ngrx/store';
import {User} from "../../../../user/user";
import {filter, switchMap} from "rxjs/operators";
import {Subscription} from "rxjs";
import {UserSubscription, UserSubscriptionType} from "../../../../user/user-subscription";
import {Config} from "../../../../config/config";
import {clientRoles} from "../../../../user/user-roles-actions";
import {combineLatest} from "rxjs";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import {DbModalService} from "../../../../modules/modal/modal";
import {CookieService} from "ngx-cookie";
import {
    OneWeekFreeDemoUpgradeComponent
} from "../../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {Utils} from "../../../../shared/utils/utils";
import {
    ApiResellerProComponent
} from "../../../../shared/components/dialogs/api-reseller-pro/api-reseller-pro.component";
import {
    PricingPageViewComponent
} from "../../../../shared/components/dialogs/one-month-free/components/pricing-page-view/pricing-page-view.component";
import {
    PaidFeatureUpgradeComponent
} from "../../../../shared/components/dialogs/paid-feature-upgrade/paid-feature-upgrade.component";

@Component({
    selector: 'db-hosting-info',
    templateUrl: './hosting-info.component.html',
    styleUrls: ['./hosting-info.component.scss'],
    standalone: false
})
export class HostingInfoComponent implements OnInit, OnDestroy {

    public hostingInfoData: HostingData;
    public website: Website;
    public isCopiedSftpHost: boolean;
    public isCopiedSftpUsername: boolean;
    public isCopiedSftpPassword: boolean;
    public isCopiedSftpPort: boolean;
    public isCopiedDatabasePassword: boolean;
    public isCopiedDatabaseUsername: boolean;
    public isCopiedSSH: boolean;
    public isMobile: boolean;
    public site_url: string;
    public showPassword: boolean = false;
    public showDbPassword: boolean = false;
    public showSSHPassword: boolean = false;
    public hasHostingBanner: any;
    public hostingPhpAdminAutologin: any;
    public user: User;
    private _subscriptions: Subscription[];
    public logoutUser: string = '';
    private currentWorkspaceId: any;
    private userRole: any;
    public currentSubscription: UserSubscription;
    public UserSubscriptionType: any = UserSubscriptionType;
    public hideUpgradeButton: boolean = false;
    public firstInfoLink: string = "https://help.10web.io/hc/en-us/articles/360030819671-How-to-Change-the-SFTP-Password";
    public secondInfoLink: string = "https://help.10web.io/hc/en-us/articles/360027578632-How-to-Use-SFTP-to-Access-Your-Theme-Uploads-and-Plugins-";
    public thirdInfoLink: string = "https://help.10web.io/hc/en-us/articles/360029790692-How-to-run-a-query-in-phpMyAdmin";
    public readonly defaultStarterPlanId = Config.defaultStarterPlanId;
    demoUser: boolean = false;

    constructor(
        private _route: ActivatedRoute,
        private _router: Router,
        private _store: Store<fromStore.DbStoreState>,
        private _hostingService: HostingService,
        private _dialogService: DialogService,
        // private _malihuScrollbarService: MalihuScrollbarService,
        private _googleAnalyticsService: GoogleAnalyticsService,
        private _modalService: DbModalService,
        private _cookieService: CookieService
    ) {
    }

    ngOnInit(): void {
        this.isMobile = window.innerWidth <= 991;

        if (!this.isMobile) {
            // document.getElementById("db-hosting-info") && this._malihuScrollbarService.initScrollbar(document.getElementById("db-hosting-info"), Object.assign(Config.malihuScrollbarDefaultOptions, {
            //     callbacks: {
            //       onScroll: () => {
            //         const tooltipInfo = <HTMLElement>document.getElementsByTagName("db-info-tooltip")[0];
            //         if (tooltipInfo !== null && !TypeUtils.isUndefined(tooltipInfo)) {
            //           tooltipInfo.innerHTML = "";
            //         }
            //       }
            //     }
            //   })
            // );
        }

        this.user = this._route.snapshot.parent.parent.data['user'];
        this.hasHostingBanner = localStorage.getItem("showConnectBanner" + this.user.id);
        this.hostingInfoData = this._route.snapshot.data['hostingInfoData'];
        this.website = this._route.snapshot.parent.parent.data['website'];
        this.site_url = this.website.site_url.replace(/(^\w+:|^)\/\//, '');
        this.getDbUrl();
        this.getData();
        this.addEventHandlers();
    }

    private addEventHandlers(): void {
        this._subscriptions = [];
        this._subscriptions.push(
            this._store.select(fromStore.getInfo(this.website.id)).subscribe((hostingInfo: any) => {
                if (hostingInfo) {
                    this.hostingInfoData = hostingInfo;
                }
            })
        );

        this._subscriptions.push(
            this._store.select(fromStore.getUserLoaded)
                .pipe(
                    filter((loaded: boolean) => loaded),
                    switchMap(() => combineLatest(
                        this._store.select(fromStore.getWorkspaceIdEntities),
                        this._store.select(fromStore.getUserSubscription)
                    ))
                )
                .subscribe(([workspaceIdEntities, currentSubscription]) => {
                    this.demoUser = Utils.isDemoUser(currentSubscription, this.user);
                    this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || workspaceIdEntities.ownerWorkspaceId;
                    this.currentSubscription = currentSubscription;
                    this.userRole = this.user && this.user.workspaces.find(el => el.workspaceId === this.currentWorkspaceId);
                    this.hideUpgradeButton = this.userRole && [clientRoles.COMPANY_DEV, clientRoles.SITE_DEV].includes(this.userRole.roleId);
                })
        );
    }

    public openSql(): void {
        this.getDbUrl();
        localStorage.setItem('dbUserName', this.hostingInfoData.hostingDatabase.username);
    }

    public getDbUrl(): void {
        if (localStorage.getItem('dbUserName') && this.replaceURL(localStorage.getItem('dbUserName')) === this.replaceURL(this.hostingInfoData.hostingDatabase.username)) {
            this.logoutUser = "old_usr=" + (this.website.type === "live" ? 'dev_' : 'live_') + this.replaceURL(this.hostingInfoData.hostingDatabase.username) + '&';
            this.hostingPhpAdminAutologin = this.hostingInfoData.hostingDatabase.path;
            /*TODO find other way to autologin
            + '/index.php'?db=& + this.logoutUser + "pma_username=" + this.hostingInfoData.hostingDatabase.username + "&pma_password=" + this.hostingInfoData.hostingDatabase.password*/
        } else {
            this.hostingPhpAdminAutologin = this.hostingInfoData.hostingDatabase.path;
            /*TODO find other way to autologin
             + "?pma_username=" + this.hostingInfoData.hostingDatabase.username + "&pma_password=" + this.hostingInfoData.hostingDatabase.password
             */
        }
    }

    public replaceURL(url: string): any {
        return url.replace('live_', '').replace('dev_', '');
    }

    public copiedSftpHost() {
        this.isCopiedSftpHost = true;
        setTimeout(() => this.isCopiedSftpHost = false, 800);
    }

    public copiedSftpUsername() {
        this.isCopiedSftpUsername = true;
        setTimeout(() => this.isCopiedSftpUsername = false, 800);
    }

    public copiedSftpPassword() {
        this.isCopiedSftpPassword = true;
        setTimeout(() => this.isCopiedSftpPassword = false, 800);
    }

    public copiedSftpPort() {
        this.isCopiedSftpPort = true;
        setTimeout(() => this.isCopiedSftpPort = false, 800);
    }

    public copiedDatabasePassword() {
        this.isCopiedDatabasePassword = true;
        setTimeout(() => this.isCopiedDatabasePassword = false, 800);
    }

    public copiedDatabaseUsername() {
        this.isCopiedDatabaseUsername = true;
        setTimeout(() => this.isCopiedDatabaseUsername = false, 800);
    }

    public copiedSSH() {
        this.isCopiedSSH = true;
        setTimeout(() => this.isCopiedSSH = false, 800);
    }

    public getData() {

    }

    public togglePassword() {
        this.showPassword = !this.showPassword;
    }

    public toggleDbPassword() {
        this.showDbPassword = !this.showDbPassword;
    }

    public toggleSSHPassword() {
        this.showSSHPassword = !this.showSSHPassword;
    }

    public generatePasswordClicked(type: string) {
        this._dialogService
            .addDialog(GeneratePasswordComponent, {
                websiteId: this.website.id,
                generatingFor: type
            })
            .subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this._store.dispatch(new fromStore.LoadInfo(this.website.id));
                    // this.generateSftpPassword();
                }
            });
    }


    public showCheckoutDialog(label: string): void {
        if (this.currentSubscription && this.currentSubscription.status === 'canceled') {
            this._router.navigate(['/workspace/subscription-plan']);
        } else {
            this._router.navigate(['/upgrade-plan']);
        }
    }

    ngOnDestroy(): void {

    }
}
